<mat-paginator
  #paginator
  showFirstLastButtons="true"
  [length]="length()"
  [pageSize]="pageSize"
  [pageIndex]="isGroupedView() ? null : pageIndex()"
  [pageSizeOptions]="pageSizeOptions"
  (page)="pageEvent = onPaginatorChange($event)"
  aria-label="Select page"
></mat-paginator>
